import { useState } from 'react';
import styled from 'styled-components';
import EmployeeKpiReportSearchBox from './components/EmployeeKpiReportSearchBox';
import EmployeeKpiTable from './components/EmployeeKpiTable';
import { getEmployeeKpiReport } from '@/API/repositories/reports';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import Loading from '@/common/components/Loading';
import { DEFAULT_KPI_THRESHOLDS } from './config/kpiThresholds';
import { parseApiResponse } from './helper/parseApiResponse';

const Wrapper = styled.div`
	padding: 20px;
	width: 95vw;
`;

const TablesContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 40px;
	margin-top: 40px;
`;

const EmployeeKpiReport = () => {
	const [t, setT] = useState({
		confirmed: DEFAULT_KPI_THRESHOLDS.CONFIRMED,
		delivered: DEFAULT_KPI_THRESHOLDS.DELIVERED,
	});
	const [rows, setRows] = useState([]);
	const [dates, setDates] = useState([]);

	const { hasUnfilledRequest, makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const {
		commonData: { users },
	} = useCommonDataContext();

	const handleSearchCallback = async (payload) => {
		const res = await makeRequest(getEmployeeKpiReport.bind(null, payload));

		if (!res?.data) {
			return addMessage('Błąd pobierania danych', 'error');
		}

		const parsed = parseApiResponse(res.data, users);
		setRows(parsed);

		const allDates = [
			...new Set(parsed.flatMap((r) => r.dates.map((d) => d.date))),
		].sort((a, b) => new Date(a).getTime() - new Date(b).getTime());

		setDates(allDates);
	};

	return (
		<>
			{hasUnfilledRequest(getEmployeeKpiReport) && <Loading />}
			<Wrapper>
				<EmployeeKpiReportSearchBox
					handleSearchCallback={handleSearchCallback}
					setT={setT}
				/>
				{rows.length > 0 && (
					<TablesContainer>
						<EmployeeKpiTable
							title='Confirmed/H'
							rows={rows}
							dates={dates}
							kpiKey='confirmedPerH'
							countKey='confirmed'
							threshold={t.confirmed}
						/>
						<EmployeeKpiTable
							title='Delivered/H'
							rows={rows}
							dates={dates}
							kpiKey='deliveredPerH'
							countKey='delivered'
							threshold={t.delivered}
						/>
					</TablesContainer>
				)}
			</Wrapper>
		</>
	);
};

export default EmployeeKpiReport;
